import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { SERVER_URL } from "../api";

import footer1 from "../image/sideNav/home.png";
import footer1Active from "../image/sideNav/homeActive.png";

import footer2 from "../image/sideNav/history.png";
import footer2Active from "../image/sideNav/historyActive.png";

import footer3 from "../image/sideNav/deposit.png";
import footer3Active from "../image/sideNav/depositActive.png";

import footer4 from "../image/sideNav/profile.png";
import footer4Active from "../image/sideNav/profileActive.png";

// import footer5 from "../image/7.png";
// import footer5Active from "../image/6.png";

import { useAuth } from "../helper";
import Constant from "../consts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDice } from "@fortawesome/free-solid-svg-icons";

// ★ Cache wheel config ໃນ sessionStorage ເພື່ອບໍ່ fetch ທຸກຄັ້ງທີ່ navigate
const WHEEL_CACHE_KEY = "cache_wheel_active";
const WHEEL_CACHE_TTL = 5 * 60 * 1000; // 5 ນາທີ

function getWheelCache() {
  try {
    const raw = sessionStorage.getItem(WHEEL_CACHE_KEY);
    if (!raw) return null;
    const entry = JSON.parse(raw);
    if (Date.now() - entry.ts > WHEEL_CACHE_TTL) {
      sessionStorage.removeItem(WHEEL_CACHE_KEY);
      return null;
    }
    return entry.active;
  } catch { return null; }
}

function setWheelCache(active) {
  try {
    sessionStorage.setItem(WHEEL_CACHE_KEY, JSON.stringify({ active, ts: Date.now() }));
  } catch {}
}

export default function FooterBar() {
  const history = useHistory();
  const Location = useLocation();
  const isAuthenticated = useAuth();
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const [dataLogin, setDataLogin] = useState();
  const [wheelActive, setWheelActive] = useState(false);

  useEffect(() => {
    _checkLogin();
  }, [isAuthenticated]);

  useEffect(() => {
    const _Language = JSON.parse(localStorage.getItem("Language"));
    i18n.changeLanguage(_Language);
    // ★ ໃຊ້ cache ກ່ອນ → ຖ້າມີ cache ບໍ່ຕ້ອງ fetch API
    const cached = getWheelCache();
    if (cached !== null) {
      setWheelActive(cached);
      return;
    }
    // Fetch wheel config to check if active (API ສົ່ງ data=null ຖ້າປິດ, ສົ່ງ object ຖ້າເປີດ)
    axios.get(SERVER_URL + "/api/v1/prize-wheel/config")
      .then((res) => {
        const active = !!res.data?.data;
        setWheelActive(active);
        setWheelCache(active);
      })
      .catch(() => setWheelActive(false));
  }, []);

  const _checkLogin = async () => {
    const isAuth = useAuth();
    if (!isAuth) {
      setDataLogin(false);
    } else {
      setDataLogin(true);
    }
    return;
  };
  const _nextPage = (route) => {
    if (!dataLogin) {
      Swal.fire({
        icon: "error",
        title: t("FooterLoginFirst"),
      });
      return;
    }
    history.push(route);
  };

  return (
    <div>
      <footer className="footer">
        <div
          className="footer-btn"
          onClick={() => history.push(Constant.PAGE_HOME)}
        >
          <img
            src={
              Location?.pathname === Constant.PAGE_HOME
                ? footer1Active
                : Location?.pathname.split("/")[1] === "game-detail"
                ? footer1Active
                : footer1
            }
            alt="Footer 1"
            style={{ width: 30, height: 30 }}
          />
          <div>{t("FootterHome")}</div>
        </div>
        <div
          className="footer-btn"
          onClick={() =>
            dataLogin
              ? history.push(Constant.HISTORY_GAME_INVOICE + "/limit/20/skip/1")
              : _nextPage()
          }
        >
          <img
            src={
              Location?.pathname === Constant.HISTORY_GAME_INVOICE
                ? footer2Active
                : ["history-invoice", "history-recharge","history-games"].includes(
                    Location?.pathname.split("/")[1]
                  )
                ? footer2Active
                : footer2
            }
            alt="Footer 1"
            style={{ width: 30, height: 30 }}
          />
          <div>{t("FootterHistory")}</div>
        </div>
        {wheelActive && (
        <div
          className="footer-btn"
          onClick={() =>
            dataLogin ? history.push(Constant.PRIZE_WHEEL) : _nextPage()
          }
          style={{
            position: 'relative',
          }}
        >
          <div style={{
            width: 42,
            height: 42,
            borderRadius: '50%',
            background: Location?.pathname === Constant.PRIZE_WHEEL
              ? 'linear-gradient(135deg, #f5576c, #ff6b6b)'
              : 'linear-gradient(135deg, #667eea, #764ba2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '-12px auto 0',
            boxShadow: '0 4px 15px rgba(118, 75, 162, 0.4)',
            border: '2px solid rgba(255,215,0,0.3)',
          }}>
            <FontAwesomeIcon icon={faDice} style={{ fontSize: 18, color: '#FFD700' }} />
          </div>
          <div style={{ fontSize: '0.65rem', marginTop: 2 }}>{t("FooterWheel")}</div>
        </div>
        )}
        <div
          className="footer-btn"
          onClick={() =>
            dataLogin ? history.push(Constant.RECHARGE) : _nextPage()
          }
        >
          <img
            src={
              Location?.pathname === Constant.RECHARGE ? footer3Active : footer3
            }
            alt="Footer 1"
            style={{ width: 30, height: 30 }}
          />
          <div>{t("FootterMoney")}</div>
        </div>
        <div
          className="footer-btn"
          onClick={() =>
            dataLogin ? history.push(Constant.PROFILE) : _nextPage()
          }
        >
          <img
            src={
              Location?.pathname === Constant.PROFILE ? footer4Active : footer4
            }
            alt="Footer 1"
            style={{ width: 30, height: 30 }}
          />
          <div>{t("FootterProfile")}</div>
        </div>
      </footer>
    </div>
  );
}
